import React, { useEffect, useRef, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";

const inputStyle = { background: "var(--bg-surface)", border: "1px solid var(--border)", color: "var(--text-primary)" };

export function LocationAutocomplete({ value, onChange, testid }) {
  const [q, setQ] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useRef();

  useEffect(() => { setQ(value || ""); }, [value]);

  const search = (text) => {
    setQ(text);
    onChange(text);
    setOpen(true);
    clearTimeout(timer.current);
    if (text.trim().length < 3) { setResults([]); return; }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const r = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(text)}&limit=5`);
        const d = await r.json();
        const seen = new Set();
        const out = [];
        (d.features || []).forEach((f) => {
          const p = f.properties || {};
          const parts = [p.name, p.city, p.state, p.country].filter(Boolean);
          const label = [...new Set(parts)].join(", ");
          if (label && !seen.has(label)) { seen.add(label); out.push(label); }
        });
        setResults(out);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 350);
  };

  const pick = (label) => { onChange(label); setQ(label); setResults([]); setOpen(false); };

  return (
    <div>
      <div className="flex items-center gap-2 rounded-xl px-3" style={inputStyle}>
        <MapPin size={15} style={{ color: "var(--text-muted)" }} />
        <input value={q} onChange={(e) => search(e.target.value)}
          onFocus={() => q.trim().length >= 3 && results.length > 0 && setOpen(true)}
          placeholder="Search a place…" data-testid={testid}
          className="flex-1 bg-transparent py-3 text-sm outline-none min-w-0" style={{ color: "var(--text-primary)" }} />
        {loading && <Loader2 size={14} className="animate-spin" style={{ color: "var(--text-muted)" }} />}
      </div>
      {open && results.length > 0 && (
        <div className="mt-1.5 rounded-xl overflow-hidden" style={{ background: "var(--bg-elevated)", border: "1px solid var(--border)" }}>
          {results.map((r, i) => (
            <button key={i} type="button" onClick={() => pick(r)} data-testid={`${testid}-opt-${i}`}
              className="w-full text-left px-3 py-2.5 text-sm"
              style={{ color: "var(--text-primary)", borderTop: i ? "1px solid var(--hairline)" : "none" }}>
              {r}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
